import updateObject from "../../util/updateObject";
import * as actionTypes from "./actionTypes";
import { initialTransferLogTable } from "./helper";

const initialState = {
    transferLogTable: initialTransferLogTable,
};

const mergeTable = (state, patch) =>
    updateObject(state, { transferLogTable: updateObject(state.transferLogTable, patch) });

const transferLogReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.GET_TRANSFER_LOG_TABLE:
            return mergeTable(state, { [action.key]: action.value });

        case actionTypes.SET_TRANSFER_LOG_PAGE_DATA: {
            const payload = action.payload ?? {};
            return mergeTable(state, {
                items: payload.items ?? [],
                totalElements: payload.totalElements ?? 0,
                page: payload.page ?? 0,
                size: payload.size ?? state.transferLogTable.size,
                serverTime: payload.serverTime ?? state.transferLogTable.serverTime,
                newEntriesCount: 0,
            });
        }

        case actionTypes.PREPEND_TRANSFER_LOG_ITEMS: {
            const existingIds = new Set(state.transferLogTable.items.map(i => i.id));
            const fresh = (action.items ?? []).filter(i => !existingIds.has(i.id));
            if (fresh.length === 0) {
                return mergeTable(state, { serverTime: action.serverTime ?? state.transferLogTable.serverTime });
            }
            return mergeTable(state, {
                items: [...fresh, ...state.transferLogTable.items],
                totalElements: state.transferLogTable.totalElements + fresh.length,
                serverTime: action.serverTime ?? state.transferLogTable.serverTime,
                newEntriesCount: state.transferLogTable.newEntriesCount + fresh.length,
            });
        }

        case actionTypes.ACKNOWLEDGE_NEW_ENTRIES:
            return mergeTable(state, { newEntriesCount: 0 });

        case actionTypes.SET_TRANSFER_LOG_FILTERS:
            return mergeTable(state, { filters: action.filters, page: 0 });

        case actionTypes.SET_TRANSFER_LOG_PAGE:
            return mergeTable(state, { page: action.page });

        case actionTypes.SET_TRANSFER_LOG_SIZE:
            return mergeTable(state, { size: action.size, page: 0 });

        default:
            return state;
    }
};

export default transferLogReducer;
